import { Link } from 'react-router-dom';
import { calendarDays } from '@/mocks/calendar';

export default function CalendarPreview() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="mx-auto max-w-2xl text-center">
        <span className="text-sm font-semibold tracking-wide text-accent-700">追漫日历</span>
        <h2 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">一周连载一目了然</h2>
        <p className="mt-4 text-foreground-600">
          每天该追哪部、几时更新，追漫日历帮你安排得明明白白，连载节奏尽在掌握。
        </p>
      </div>

      <div className="mt-12 grid grid-cols-2 gap-4 sm:grid-cols-4 lg:grid-cols-7">
        {calendarDays.map((day, idx) => (
          <div
            key={day.day}
            className={`rounded-2xl border p-4 ${
              idx === 4
                ? 'border-primary-300 bg-primary-50'
                : 'border-background-200/70 bg-background-50'
            }`}
          >
            <div className="flex items-center justify-between">
              <span className="text-sm font-bold text-foreground-950">{day.day}</span>
              <span className="text-xs text-foreground-500">{day.date}</span>
            </div>
            <div className="mt-4 space-y-3">
              {day.items.map((item) => (
                <div key={item.title} className="rounded-xl bg-background-100 p-3">
                  <p className="text-xs font-semibold text-foreground-900">{item.title}</p>
                  <div className="mt-1 flex items-center justify-between">
                    <span className="text-[11px] text-foreground-500">{item.chapter}</span>
                    <span className="flex items-center gap-1 text-[11px] text-primary-600">
                      <i className="ri-time-line"></i>
                      {item.time}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      <div className="mt-8 text-center">
        <Link
          to="/calendar"
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-accent-500 px-6 py-3 text-sm font-semibold text-foreground-950 transition-colors hover:bg-accent-600"
        >
          查看完整追漫日历
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}